import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { ItemAttributeChildLinkContainerModel } from '../../../../../../models/aggregates/erp/attribute/item-attribute-child-link-container.model';
import { ApiResponseModel, ApiVisa } from '../../shared';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ItemAttributeChildLinkService extends BaseApiTemplateService<ItemAttributeChildLinkContainerModel> {
  // https://api-test.akaun.com/core2/tnt/dm/erp/attribute/fi-item-attribute-child-links
  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ERP_PREFIX + 'attribute' + '/fi-item-attribute-child-links';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'attribute' + '/fi-item-attribute-child-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'attribute' + '/fi-item-attribute-child-links';
    this.httpClient = http;
  }

  updateSequenceNoForAllLinkedChildItems(attributeSortNumberDto: any, visa: ApiVisa): Observable<ApiResponseModel<ItemAttributeChildLinkContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + `/update-sequence-no`;
    }
    return this.httpClient.post<ApiResponseModel<ItemAttributeChildLinkContainerModel>>(this.apiUrl, attributeSortNumberDto, this.getHttpHeaderJson(visa))
  }

  public attributeBackoffice(
    groupItemHdrGuid: string,
    visa: ApiVisa
  ): Observable<ApiResponseModel<ItemAttributeChildLinkContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/child-items-attribute-links/' + groupItemHdrGuid;
    }

    return this.httpClient.get<ApiResponseModel<ItemAttributeChildLinkContainerModel>>(
      this.apiUrl,
      this.getHttpHeaderJson(visa)
    );
  }

   public getItemAttributeChildLinks(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      url = this.apiUrl + '/query/backoffice-ep';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

}
